import { BackendPaginatedResponse, SearchParamDefaults } from 'common/types'
import { createQueryMap } from 'common/utils/createQueryMap'
import { searchQueryBuilder } from 'common/utils/searchQueryBuilder'
import { useHttp } from 'hooks/use-http/useHttp'
import { useEffect, useState } from 'react'

export const usePaginatedContent = (
  endpointSlug: string,
  searchParams: SearchParamDefaults,
  endpointSpecificSearchParams: { [key: string]: string | number }
) => {
  const { get } = useHttp()
  const [prevPage, setPrevPage] = useState<number>(typeof searchParams?.page == 'number' ? searchParams?.page - 1 : 0)
  const [items, setItems] = useState<any[]>()
  const [isLoading, setIsLoading] = useState(false)
  const [isLastPage, setIsLastPage] = useState(false)

  useEffect(() => {
    setPrevPage(0)
    setIsLastPage(false)
    setItems(null)

    getItems(true)
  }, [endpointSpecificSearchParams, searchParams, endpointSlug])

  const fetchItems = async (reset = false) => {
    setIsLoading(true)

    const query = searchQueryBuilder(createQueryMap(endpointSpecificSearchParams))

    const url = `${endpointSlug}?page=${prevPage + 1}&pageSize=${searchParams?.pageSize || 10}&dir=${
      searchParams?.dir || 'desc'
    }&sort=${searchParams?.sort || 'created_at'}${query}`

    const response = await get<BackendPaginatedResponse<any>>(url, { useApiKey: true })

    if (response) {
      const newItems = response?.data || []

      if (!response.data.length) {
        setIsLastPage(true)
      }

      setPrevPage(parseInt(response?.page))
      setItems((!!items && !reset) ? [...items, ...newItems] : newItems)
      setIsLoading(false)
    }
  }

  const getItems = async (reset = false) => {
    if (!reset && !isLoading && !isLastPage) {
      fetchItems()
    }

    if (reset) {
      fetchItems(reset)
    }
  }

  return {
    items,
    getItems,
    isLoading,
    isLastPage
  } as const
}
